import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {} ;
let token = sessionStorage.getItem("token") || '';
let appInfo = JSON.parse(localStorage.getItem('appInfo')) || {};
let messageNum = token ? localStorage.getItem("messageNum") || 0 :0;

export default new Vuex.Store({
  //state存放状态,
  state: {
    userInfo,
    token,
    messageNum,
    appInfo,
    title:''
  },
  //getter为state的计算属性
  getters: {
    
  },
  //mutations可更改状态的逻辑，同步操作
  mutations: {
    changTitle(state,name){
      state.title = name ;
    },
    changUserInfo(state){
      
        let userInfo =  localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {} ;
        state.userInfo = userInfo ;
    },
    changToken(state){

      state.token = sessionStorage.getItem('token') || ''; 
    }
    ,changMessageNum(state){
      let show = localStorage.getItem('show');
      state.messageNum = show ? 0 : localStorage.getItem('messageNum'); 
    }
    ,changappInfo(state){
      let appInfo = JSON.parse(localStorage.getItem('appInfo'))
      state.appInfo = appInfo ;
  },
  },
  //提交mutation，异步操作
  actions: {
    
  },
  // 将store模块化
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js